var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#BBC0C9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.222,
    clipPath: "url(#clip0_412_17693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12h.015M25.5 6h-15A4.5 4.5 0 0 0 6 10.5v15a4.5 4.5 0 0 0 4.5 4.5h15a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 22.5 6-6c.684-.658 1.46-1.005 2.25-1.005s1.566.347 2.25 1.005L24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 21 1.5-1.5c.684-.658 1.46-1.005 2.25-1.005s1.566.347 2.25 1.005l3 3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_17693"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgPhoto;